<template>
  <div class="collect">
    <div class="team">
      <div class="title flex-center" @click="showHome = !showHome">
        <div class="icon">
          {{ showHome ? '折叠' : '展开' }}
          <van-icon name="arrow-down" size="16px" style="margin-left: 6px;" class="is" :class="showHome ? 'van-icon1':''" />
        </div>
      </div>
      <div class="table" v-if="showHome">
        <div class="left">
          <div class="label">球员</div>
          <div v-for="(item, i) in playerList" :key="i" class="name">{{ item.trueName }}</div>
        </div>
        <div class="right">
          <div class="label">
            <div v-for="(item, i) in list" :key="item" :style="{background: i%2 === 0 ? '#0352E8':'#1565FC'}">{{ item }}</div>
          </div>
          <div class="round">
            <div v-for="(item, i) in playerList" :key="i" class="item">
              <!-- <div v-for="game,index in list" :key="game" :style="{ background: index % 2 === 0 ? '#F7F7F7' : '#fff' }">{{ index }}</div> -->
              <div>{{ item.serviceCount }}</div>
              <div>{{ item.ace }}</div>
              <div>{{ item.serviceWinCount }}</div>
              <div>{{ item.point }}</div>
              <div>{{ item.breakPoint }}</div>
              <div>{{ item.breakPointSuccess }}</div>
              <div>{{ item.unforcedError }}</div>
              <div>{{ item.doubleError }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getBMMatchTennisGamePlayerList } from "@/api/match";

export default {
  data() {
    return {
      is: true,
      list: ['发球总数', 'ACE球', '发球成功数', '发球得分数', '破发点', '破发局数','非受迫性失误', '双误'],
      gameId: '',
      playerList: [],
      showHome: true,
      awayTeam: {},
      showAway: true
    }
  },
  mounted() {
    this.gameId = this.$route.query.gameId
    this.matchId = this.$route.query.matchId
    this.getBMMatchTennisGamePlayerList()
  },
  methods: {
    getBMMatchTennisGamePlayerList() {
      const params = {
        matchId: this.matchId,
        gameId: this.gameId
      }
      getBMMatchTennisGamePlayerList(params).then(res => {
        if (res) {
          const { data } = res
          this.playerList = data.playerList
        }
      })
    }
  },
};
</script>

<style scoped lang="scss">
.collect{
  min-height: 100vh;
  background: #F6F6F8;
  .title{
    padding: 19px 16px 13px 16px;
    font-size: 14px;
    .name{
      font-weight: 500;
      color: rgba(0,0,0,0.8);
    }
    .icon{
      color: #9A9A9A;
      .is{
        transition: 0.1s linear;
      }
      .van-icon1{
        transform: rotateX(-180deg);
      }
    }
  }
  .table{
    padding-left: 16px;
    display: flex;
    .left{
      .label{
        min-width: 112px;
        box-sizing: border-box;
        background: #1565FC;
        border-radius: 4px 0px 0px 0px;
        padding: 8px 0px 8px 24px;
        color: #fff;
        font-size: 14px;
        text-align: left;
      }
      .name{
        width: 112px;
        height: 53px;
        box-sizing: border-box;
        text-align: center;
        background-color: #fff;
        border-bottom: 1px solid #E6E6E6;
        padding: 16px 0;
        font-size: 14px;
      }
    }
    .right{
      overflow: scroll;
      .label{
        display: flex;
        div{
          min-width: 112px;
          box-sizing: border-box;
          text-align: center;
          background: #0352E8;
          color: #fff;
          font-size: 14px;
          padding: 8px 0;
        }
      }
      .round{
        // display: flex;
        .item{
          display: flex;
          div{
            height: 53px;
            font-size: 14px;
            min-width: 112px;
            padding: 16px 0;
            background-color: #fff;
            border-bottom: 1px solid #E6E6E6;
            box-sizing: border-box;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
